import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./routes.js"
import Toast from "@/components/toast"

import appInteraction from "@/common/appInteraction.js";
//导航
import navigation from "@js/navigation"

Vue.use(VueRouter)
const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE,
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  Toast.closeAll();
  next();
});
router.afterEach((to, from) => {
    //app原生后退调用
    appInteraction.backPage(()=>{
      navigation.back();
    })
    if(to.meta.NavBar){
      appInteraction.setTabStyle(to.meta.NavBar);
    }else{
      appInteraction.setTabStyle({NavigationBar:1,Show:0});
    }
});

export default router;
